<template>
  <basic-container>
    <div class="search_group">
      <el-input :maxlength="30" v-model="orderNo" size="small" placeholder="输入订单编号"></el-input>
      <el-input :maxlength="30" v-model="userAccount" size="small" placeholder="用户账户"></el-input>
      <el-date-picker v-model="searchTime" type="date" value-format="yyyy-MM-dd" size="small" placeholder="申请时间"></el-date-picker>
      <el-select @change="searchAct" v-model="searchStatus" size="small" clearable placeholder="补单状态">
        <el-option label="待处理" :value="1"></el-option>
        <el-option label="已补单" :value="2"></el-option>
        <el-option label="已拒绝" :value="3"></el-option>
      </el-select>
      <el-select @change="searchAct" v-model="payType" size="small" clearable placeholder="支付方式">
        <el-option label="微信" :value="1"></el-option>
        <el-option label="支付宝" :value="2"></el-option>
        <el-option label="IOS内购" :value="5"></el-option>
      </el-select>
      <el-button @click="searchAct" icon="el-icon-search" size="small" type="primary">查询</el-button>
      <el-button @click="exportList" v-auth="'memberFix_export'" icon="el-icon-download" size="small" type="primary">导出</el-button>
    </div>
    <el-table :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}" :max-height="tableHeight"
      v-loading="listLoading" element-loading-text="加载中" border :data="tableData">
      <el-table-column fixed prop="orderId" label="订单编号" width="200"></el-table-column>
      <el-table-column prop="productName" label="补单商品名称" width="150"></el-table-column>
      <el-table-column prop="producTypetName" label="商品类型" width="120"></el-table-column>
      <el-table-column prop="mobile" label="用户账号" width="120"></el-table-column>
      <el-table-column prop="createTime" label="申请时间" width="180"></el-table-column>
      <el-table-column label="支付方式">
        <template slot-scope="scope">{{scope.row.payType | payType}}</template>
      </el-table-column>
      <el-table-column label="用户凭证">
        <template slot-scope="scope">
          <el-image fit="fill" :src="scope.row.attachment" :preview-src-list="[scope.row.attachment]"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="补单状态">
        <template slot-scope="scope">{{scope.row.supplementReviewStatus | fixStatus}}</template>
      </el-table-column>
      <el-table-column prop="reviewTime" label="处理时间" width="180"></el-table-column>
      <el-table-column prop="reviewUserName" label="处理人"></el-table-column>
      <el-table-column fixed="right" width="150" label="操作">
        <template slot-scope="scope">
          <el-button @click="openDetail(scope.row,2)" v-if="scope.row.supplementReviewStatus==1" v-auth="'memberFix_handle'" icon="el-icon-info" size="mini" type="text">处理补单</el-button>
          <el-button @click="openDetail(scope.row,1)" v-if="scope.row.supplementReviewStatus!=1" v-auth="'memberFix_detail'" icon="el-icon-info" size="mini" type="text">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="table_pagination">
      <el-pagination class="app-pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageNo" :page-sizes="pageSizeArr" :page-size="pageSize" :layout="paginationLayout" :total="totalEl">
      </el-pagination>
    </div>
    <el-dialog title="订单详情" :visible.sync="showDetails" append-to-body width="40%">
      <el-form :model="checkItem" size="mini" label-position="left" label-width="140px">
        <el-form-item label="订单编号">{{checkItem.orderId}}</el-form-item>
        <el-form-item label="用户账号">{{checkItem.mobile}}</el-form-item>
        <el-form-item label="订单商品名称">{{checkItem.productName}}</el-form-item>
        <el-form-item label="用户凭证" class="form-upload-img">
          <img :src="checkItem.attachment" alt="">
        </el-form-item>
        <el-form-item label="支付方式">{{checkItem.payType | payType}}</el-form-item>
        <el-form-item label="订单创建时间">{{checkItem.orderId}}</el-form-item>
        <el-form-item label="申请操作人">{{checkItem.reviewCreateName}}</el-form-item>
        <el-form-item label="申请操作时间">{{checkItem.createTime}}</el-form-item>
        <h3>补单信息</h3>
        <el-form-item label="补单商品名称">{{checkItem.productName}}</el-form-item>
        <el-form-item label="补单状态">{{checkItem.supplementReviewStatus | fixStatus}}</el-form-item>
        <template v-if="checkItem.detailType==1">
          <el-form-item label="处理人">{{checkItem.reviewUserName}}</el-form-item>
          <el-form-item label="处理时间">{{checkItem.reviewTime}}</el-form-item>
          <el-form-item label="备注">{{checkItem.reviewContent}}</el-form-item>
        </template>
        <el-form-item v-if="checkItem.detailType==2" label="备注">
          <el-input type="textarea" :rows="3" :maxlength="150" resize="none" v-model="handleRemark" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDetails=false" v-if="checkItem.detailType==1" size="small" type="primary" icon="el-icon-circle-check">确认</el-button>
        <el-button @click="changeCheck(2)" v-if="checkItem.detailType==2" v-auth="'memberFix_handle'" size="small" type="primary" icon="el-icon-circle-check">确认补单</el-button>
        <el-button @click="changeCheck(3)" v-if="checkItem.detailType==2" v-auth="'memberFix_handle'" size="small" type="danger" icon="el-icon-circle-close">拒绝补单</el-button>
      </div>
    </el-dialog>
  </basic-container>
</template>

<script>
import { supplementList, reviewForSupplement } from '@/api/member'
import { exportOrderList } from '@/services'
import { debounce, deepCopy } from '@/util/common'
import pagination from '@/util/mixins/pagination'
export default {
  mixins: [pagination],
  data () {
    return {
      orderNo: '', // 订单编号
      userAccount: '', // 用户账户
      searchTime: '', // 时间
      searchStatus: '', // 开票状态
      payType: '', // 支付方式
      checkItem: {}, // 查看项
      handleRemark: '', // 处理备注
      showDetails: false // 详情弹窗
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    // 打开弹窗
    openDetail (item, type) {
      this.checkItem = deepCopy(item)
      this.checkItem.detailType = type
      this.handleRemark = ''
      this.showDetails = true
    },
    // 获取列表
    getList () {
      this.listLoading = true
      let postData = {
        reviewCode: 10,
        orderId: this.orderNo,
        mobile: this.userAccount,
        reviewTime: this.searchTime,
        supplementReviewStatus: this.searchStatus,
        payType: this.payType,
        current: this.pageNo,
        size: this.pageSize
      }
      let onSuccess = res => {
        this.listLoading = false
        if (res.data.code === 200) {
          this.tableData = res.data.data.records
          this.totalEl = res.data.data.total
        } else {
          this.$message.error(res.data.msg)
        }
      }
      supplementList(postData).then(onSuccess).catch(() => { this.listLoading = false })
    },
    // 处理补单
    changeCheck: debounce(function (status) {
      if (!this.handleRemark && status === 3) {
        this.$message.warning('请输入备注')
        return
      }
      reviewForSupplement({
        content: this.handleRemark,
        bizRefrenceId: this.checkItem.orderId,
        status: status
      }).then(res => {
        this.listLoading = false
        if (res.data.code === 200) {
          this.showDetails = false
          this.getList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }, 300, false),
    // 导出
    exportList () {
      let postData = {
        reviewCode: 10,
        orderId: this.orderNo,
        mobile: this.userAccount,
        reviewTime: this.searchTime,
        supplementReviewStatus: this.searchStatus,
        payType: this.payType
      }
      exportOrderList(postData)
    }
  }
}
</script>
<style lang="scss">
.form-upload-img {
  .el-form-item__content img {
    width: 200px;
    margin-right: 10px;
    display: inline-block;
  }
}
</style>
